var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('div',{staticClass:"text-center mt-4"},[_c('i',{staticClass:"fas fa-3x fa-search-minus"}),_c('h2',[_vm._v("Test not found.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }